import moment from "moment";
import {appConfig} from "../../config/app.conf";

const state = {
    // { id: refugioId, fechas: ['YYYY-MM-DD'...], bloqueadas: ['YYYY-MM-DD'...], cerrado: [], online:[], nodisponible:[] }
    items: [],
    entrada: '',
    personas: 0,
    diasPosibles: [],
    diasEscogidos: [],
    // {id: rutaId, name, reference, longitud, ascenso, descenso, tiempo, vuelta}
    rutas: []

}

const getters = {
    refugiosCuaderno: (state, getters, rootState) => {
        return state.items.map(({id, fechas, bloqueadas}) => {
            const refugio = rootState.refugios.all.find(ref => ref.id === id)

            const dato = {
              id: refugio.id,
              name: refugio.name,
              calendario: refugio.fechas,
              fechas,
              bloqueadas,
              xsalto: refugio.xsalto
            };
            return dato;
        });
    },
    rutasCuaderno: state => {
        return state.rutas
    },
    refugiosTotales: state => {
        return state.items.length
    }
}

const actions = {
    // data = {refugioId, fecha}
    addRefugio({state, commit}, data) {
        const refugioId = parseInt(data.id);
        const xsalto = data.xsalto;
        const registrarFecha = data.registrarFecha
        // Cuando no hay refugios seleccionados
        if (state.items.length === 0) {
            let ref = {
              id: refugioId,
              fechas: [],
              bloqueadas: [],
              xsalto
            };
            commit('pushRefugioToCuaderno', ref)
            if(registrarFecha)
                commit("pushFechaToRefugio", {
                  refugio: ref,
                  fecha: state.entrada
                });
        } else {
            let refugio = state.items.find(ref => parseInt(ref.id) === parseInt(refugioId));

            if (refugio) {
                // Fecha debe de ser diasEscogidos[-1] + 1 dia
                const nuevoDia = moment(state.diasEscogidos[-1]).add(1, 'days');

                commit('pushFechaToRefugio', {refugio, fecha: nuevoDia.format('YYYY-MM-DD')})
                if (state.items.length > 1) {
                    state.items.forEach(ref => {
                        if (ref.id !== refugio.id) commit('pushBloqueadaToRefugio', {
                            refugio: ref,
                            fecha: nuevoDia.format('YYYY-MM-DD')
                        })
                    });
                }
            } else {
                // Cuando se inserta el refugio las fechas deben de estar vacías
                refugio = {
                    id: refugioId, 
                    fechas: [], 
                    bloqueadas: [...state.diasEscogidos],
                    xsalto
                };

                commit('pushRefugioToCuaderno', refugio)
            }
        }
    },

    removeRefugio({state, commit}, refugioId) {
        //const refugio = state.items[state.items.length - 1];
        const refugio = state.items.find(ref => ref.id === refugioId);
        refugio.fechas.forEach(fecha => {
            state.items.forEach(ref => {
                if (ref.id !== refugio.id) commit('debloquearFechaRefugio', {refugio: ref, fecha: fecha})
            })
            commit('removerFecha', fecha)
        })
        commit('removeRefugioFromCuaderno', refugioId)
        if (state.items.length === 0) commit('limpiarCuaderno')
    },

    // data = {refugioId, fecha}
    agregarDia({state, commit}, data) {

        // Comprobar si el refugio tiene la fecha seleccionada dentro de su array de fechas
        // Si la tiene se saca del array de fechas y del array de bloqueadas del resto
        // Si no se añade al array de fecha si esta disponible y se añade al arrays de bloqueadas del resto

        let refugio = state.items.find(ref => ref.id === data.refugioId);

        if (refugio.fechas.includes(data.fecha)) {

            commit('removerFechaRefugio', {fechas: refugio.fechas, fecha: data.fecha})
            state.items.forEach(ref => {
                if (ref.id !== data.refugioId) {
                    commit('removerFechaRefugio', {fechas: ref.bloqueadas, fecha: data.fecha});
                }
            })
            commit('removerFecha', data.fecha)
        } else {
            if (!state.diasEscogidos.includes(data.fecha)) {
                commit('pushFechaToRefugio', {refugio, fecha: data.fecha})
                state.items.forEach(ref => {
                    if (ref.id !== data.refugioId) {
                        commit('pushBloqueadaToRefugio', {refugio: ref, fecha: data.fecha});
                    }
                })
            }
        }

    },

    entrada({commit}, fecha) {
        const dias = []
        const inicio = moment(fecha).startOf('day');
        const fin = inicio.clone().add(appConfig.diasCuaderno, 'days').startOf('day');
        dias.push(inicio.format("YYYY-MM-DD"));
        while (inicio.add(1, 'days').diff(fin) < 0) {
            dias.push(inicio.clone().format('YYYY-MM-DD'))
        }
        commit('primerDia', {fecha, dias})
    },

    personas({commit}, personas) {
        const plazas = parseInt(personas)
        if(plazas > 0)
            commit('numeroPersonas', personas);
    },

    addRuta({state, commit}, data) {
        const objInsertar = {
            id: data.id,
            name: data.name,
            reference: data.reference,
            longitud: data.longitud,
            ascenso: data.ascenso,
            descenso: data.descenso,
            tiempo: data.tiempo,
            vuelta: data.vuelta
        };
        const posicion = state.rutas.findIndex(r => parseInt(r.id) === parseInt(objInsertar.id));
        if (posicion >= 0)
            commit("removerRuta", posicion);
        else
            commit("agregarRuta", objInsertar);
    },

    limpiarCuaderno({commit}) {
        commit('limpiarCuaderno')
    },

    reordenar({commit}, data) {
        commit('reordenar', data)
    },
    limpiarFechasRefugios({commit}) {
        commit("limpiarFechasRefugios");
    }
}

const mutations = {
    pushRefugioToCuaderno(state, data) {
        state.items.push(data)
    },
    removeRefugioFromCuaderno(state, refugioId) {
        const posicion = state.items.findIndex(ref => ref.id === refugioId)
        state.items.splice(posicion, 1);
    },
    pushFechaToRefugio(state, data) {
        //const refugio = state.items.find( ref => ref.id === data.id)
        data.refugio.fechas.push(data.fecha)
        data.refugio.fechas.sort();
        state.diasEscogidos.push(data.fecha)

    },

    removerFechaRefugio(state, data) {
        const posicion = data.fechas.indexOf(data.fecha)
        data.fechas.splice(posicion, 1);
        data.fechas.sort();
    },
    removerFecha(state,  fecha) {
        const posDia = state.diasEscogidos.indexOf(fecha)
        state.diasEscogidos.splice(posDia, 1)
    },
    pushBloqueadaToRefugio(state, data) {
        data.refugio.bloqueadas.push(data.fecha)
    },
    debloquearFechaRefugio(state, data) {
        const posicion = data.refugio.bloqueadas.indexOf(data.fecha);
        console.log(data.fecha, posicion)
        data.refugio.bloqueadas.splice(posicion, 1);
    },
    primerDia(state, data) {
        state.entrada = data.fecha
        state.diasPosibles = data.dias
    },
    numeroPersonas(state, data) {
        state.personas = data
    },
    agregarRuta(state, ruta) {
        state.rutas.push(ruta)
    },
    removerRuta(state, posicion) {
        state.rutas.splice(posicion, 1)
    },
    limpiarCuaderno(state) {
        state.items = []
        state.diasEscogidos = []
        state.diasPosibles = []
        state.rutas = []
        state.entrada = ''
    },
    reordenar(state, data) {
        const origen = state.items.findIndex(ref => ref.id == parseInt(data.origen))
        const o = state.items[origen];
        state.items.splice(origen,1);
        const destino = state.items.findIndex(ref => ref.id == parseInt(data.destino))
        state.items.splice(destino,0,o);

    },
    limpiarFechasRefugios(state) {
        for(let idx = 0; idx < state.items.length - 1; idx++ ) {
            state.items[idx].fechas = [];
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}